import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { CalculatorType } from '@/modules/tax/constants/CalculatorType';
import { Calculator } from '@/modules/tax/models/calculators/Calculator';
import { ProbateCalculator } from '@/modules/tax/models/calculators/ProbateCalculator';
import { ProbateBondCalculator } from '@/modules/tax/models/calculators/ProbateBondCalculator';
import { FinalTaxesCalculator } from '@/modules/tax/models/calculators/FinalTaxesCalculator';

export default class CalculatorModelFactory {
  static build(model: Record<string, unknown>): BaseModel {
    try {
      return this.getModel(model.type).mapModel(model);
    } catch (e) {
      return Calculator.mapModel(model);
    }
  }

  static getModel(type: string): BaseModel {
    switch (type) {
      case CalculatorType.PROBATE:
        return ProbateCalculator;
      case CalculatorType.BOND:
        return ProbateBondCalculator;
      case CalculatorType.FINAL_TAXES:
        return FinalTaxesCalculator;
      default:
        return Calculator;
    }
  }
}
